module.exports = "<pre><code class=\"lang-html\">&lt;v-stepper :steps=&quot;steps&quot; v-model=&quot;step&quot;&gt;&lt;/v-stepper&gt;\n\n&lt;template v-if=&quot;step === 1&quot;&gt;&lt;!-- Step 1 Content --&gt;&lt;/template&gt;\n&lt;template v-if=&quot;step === 2&quot;&gt;&lt;!-- Step 2 Content --&gt;&lt;/template&gt;\n&lt;template v-if=&quot;step === 3&quot;&gt;&lt;!-- Step 3 Content --&gt;&lt;/template&gt;\n\n&lt;!-- etc&#39; --&gt;\n</code></pre>\n";


//////////////////
// WEBPACK FOOTER
// ./src/markdowns/examples/default/template.md
// module id = yP6i
// module chunks = 1